/* WINGBABE · read-more · vanilla JS, no dependencies */
(function(){
document.querySelectorAll('[data-read-more]').forEach(function(b){var w=b.parentElement,txt=w&&w.querySelector('[data-read-more-text]');if(!txt)return;b.setAttribute('aria-expanded','false');
 b.addEventListener('click',function(){var o=!txt.classList.contains('is-open');txt.classList.toggle('is-open',o);b.textContent=o?'Read less':'Read more';b.setAttribute('aria-expanded',o?'true':'false');});});
})();
